class BorderAnimation {
  constructor() {
    this.containers = document.querySelectorAll('.has-border-animation .image-with-text');
    this.init();
  }

  init() {
    if (!this.containers.length) return;

    // Setup intersection observer to track when elements are in view
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.updateProgress(entry.target);
          }
        });
      },
      {
        root: null,
        rootMargin: '-20% 0px',
        threshold: Array.from({ length: 101 }, (_, i) => i / 100),
      }
    );

    // Observe all elements
    this.containers.forEach((element) => {
      this.observer.observe(element);
    });

    // Add scroll listener for smoother updates
    window.addEventListener(
      'scroll',
      () => {
        this.containers.forEach((element) => {
          if (this.isElementInView(element)) {
            this.updateProgress(element);
          }
        });
      },
      { passive: true }
    );
  }

  isElementInView(element) {
    const rect = element.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    return rect.top <= windowHeight * 0.8 && rect.bottom >= windowHeight * 0.2;
  }

  updateProgress(element) {
    const rect = element.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const startPoint = windowHeight * 0.8; // Start when element is 80% down the viewport
    const endPoint = windowHeight * 0.2; // End when element is 20% down the viewport
    const current = rect.top;

    // Calculate base progress percentage
    let progress = (startPoint - current) / (startPoint - endPoint);
    progress = Math.min(Math.max(progress, 0), 1);

    // Calculate individual side progress
    const topProgress = Math.min(progress * 4, 1) * 100;
    const rightProgress = Math.max(Math.min(progress * 4 - 1, 1), 0) * 100;
    const bottomProgress = Math.max(Math.min(progress * 4 - 2, 1), 0) * 100;
    const leftProgress = Math.max(Math.min(progress * 4 - 3, 1), 0) * 100;

    // Apply the progress to each side
    element.style.setProperty('--progress-top', `${topProgress}%`);
    element.style.setProperty('--progress-right', `${rightProgress}%`);
    element.style.setProperty('--progress-bottom', `${bottomProgress}%`);
    element.style.setProperty('--progress-left', `${leftProgress}%`);
  }
}

// Initialize on DOM content loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new BorderAnimation());
} else {
  new BorderAnimation();
}
